module.exports = __webpack_public_path__ + "img/home.5824b042.png";